module.exports = "/static/assets/47125398f6f5e43b933593236a9d8b9a.png";